import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export class PasswordValidators {
  /**
   * Validates password strength requirements matching backend Laravel rules
   * - Minimum 8 characters
   * - At least one uppercase letter
   * - At least one lowercase letter
   * - At least one number
   * - At least one special character
   */
  static strong(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const value = control.value;

      if (!value) {
        return null; // Don't validate empty values (use Validators.required for that)
      }

      const errors: ValidationErrors = {};

      // Check minimum length
      if (value.length < 8) {
        errors['minLength'] = { requiredLength: 8, actualLength: value.length };
      }

      // Check for uppercase letter (Unicode support for all languages)
      if (!/\p{Lu}/u.test(value)) {
        errors['missingUpperCase'] = true;
      }

      // Check for lowercase letter (Unicode support for all languages)
      if (!/\p{Ll}/u.test(value)) {
        errors['missingLowerCase'] = true;
      }

      // Check for number (Unicode support for all number systems)
      if (!/\p{N}/u.test(value)) {
        errors['missingNumber'] = true;
      }

      // Check for special character (any non-alphanumeric character)
      if (!/[^\p{L}\p{N}\s]/u.test(value)) {
        errors['missingSpecialChar'] = true;
      }

      return Object.keys(errors).length > 0 ? errors : null;
    };
  }

  /**
   * Get user-friendly error messages
   */
  static getErrorMessages(errors: ValidationErrors): string[] {
    const messages: string[] = [];

    if (errors['minLength']) {
      messages.push('Must be at least 8 characters long');
    }
    if (errors['missingUpperCase']) {
      messages.push('Must contain at least one uppercase letter (A-Z)');
    }
    if (errors['missingLowerCase']) {
      messages.push('Must contain at least one lowercase letter (a-z)');
    }
    if (errors['missingNumber']) {
      messages.push('Must contain at least one number (0-9)');
    }
    if (errors['missingSpecialChar']) {
      messages.push('Must contain at least one special character (!@#$%^&*()_+-=[]{}|;:,.<>?)');
    }

    return messages;
  }
}